import {
  Card,
  CardContent,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Header from "components/Header";
import { DEVICE_DETAILS } from "config";
import TranslationProvider from "providers/TranslationProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InboundSupplierVehicleForm } from "./InboundSupplierVehicleForm";
import { OutboundSupplierVehicleForm } from "./OutboundSupplierVehicleForm";
import { styled } from "@mui/system";
import { useSelector } from "react-redux";
import { updateLang } from "i18n";

const StyledMainCard = styled(Card)({
  border: `1px solid #dadce0`,
  wordWrap: "break-word",
  pageBreakInside: "avoid",
  background: "#fff",
  borderRadius: 6,
  borderTopWidth: 10,
  borderTopColor: "#1976d2",
  marginTop: 10,
});

const VehicleChecklistForm = () => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnvironment = document.querySelector(".imtime-testEnvironment");
    if (header) {
      header.style.display = "none";
    }
    if (testEnvironment) {
      testEnvironment.style.display = "none";
    }
  }, []);

  const {version} = useSelector((state)=>state.translation.i18n)
  if (version && version>1) {
    updateLang();
  }

  return (
    <Container maxWidth="sm" disableGutters>
      <form noValidate autoComplete="off">
        <Grid container direction="column" alignItems="stretch" spacing={0}>
          <Grid item >
            <TranslationProvider />
            <Header
              isLogoLinkDisabled={
                DEVICE_DETAILS.deviceType === "mobile" ? true : false
              }
            />
            <StyledMainCard>
              <CardContent sx={{padding: 0, paddingTop: "5px"}}>
                <Typography
                  variant="h6"
                  gutterBottom
                  color="textPrimary"
                  textAlign="center"
                >
                  {t("other.lblVehicleSupplierForms")}
                </Typography>
                <Grid display="flex" justifyContent="center" xs={12}>
                  <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label={t("other.lblInbound")} />
                    <Tab label={t("other.lblOutbound")} />
                  </Tabs>
                </Grid>
              </CardContent>
              <CardContent style={{padding: 0}}>
                <Grid>
                  {activeTab === 0 ? (
                    <InboundSupplierVehicleForm />
                  ) : (
                    <OutboundSupplierVehicleForm />
                  )}
                </Grid>
              </CardContent>
            </StyledMainCard>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default VehicleChecklistForm;
